document.addEventListener("DOMContentLoaded", () => {
  const button = document.getElementById("whatsappFloat");

  if (!button) return;

  button.addEventListener("click", function (e) {
    e.preventDefault();

    const phone = window.whatsappConfig?.phone || "";

    // Product Title
    const productTitle =
      document.querySelector(".product__title")?.innerText.trim() ||
      document.querySelector("h1")?.innerText.trim() ||
      window.whatsappConfig?.product ||
      "Jewellery";

    // Variant
    const variant =
      document.querySelector("[name='id'] option:checked")?.text ||
      document.querySelector(".product-form__input input:checked")?.value ||
      "";

    // Ring Size
    const ringSize =
      document.querySelector("[name='properties[Ring Size]']")?.value ||
      document.querySelector("#ring-size")?.value ||
      "";

    // Engraving
    const engraving =
      document.querySelector("[name='properties[Engraving]']")?.value ||
      document.querySelector("#engraving")?.value ||
      "";

    // Metal Purity
    const metalPurity =
      document.querySelector("[data-metal-purity].active")?.innerText ||
      "";

    // Metal Color
    const metalColor =
      document.querySelector("[data-metal-colour].active")?.innerText ||
      "";

    // Stone
    const stone =
      document.querySelector("[data-stone].active")?.innerText ||
      "";

    // Net Weight
    const netWeight =
      document.querySelector("[data-net-weight]")?.innerText || "";

    // Stone Weight
    const stoneWeight =
      document.querySelector("[data-stone-weight]")?.innerText || "";

    // Gross Weight
    const grossWeight =
      document.querySelector("[data-gross-weight]")?.innerText || "";

    let message = `Hello Carat Legacy,

I would like to request a quotation.

Product: ${productTitle}`;

    if (variant)
      message += `

Variant: ${variant}`;

    if (metalPurity)
      message += `
Metal Purity: ${metalPurity}`;

    if (metalColor)
      message += `
Metal Colour: ${metalColor}`;

    if (stone)
      message += `
Stone: ${stone}`;

    if (ringSize)
      message += `
Ring Size: ${ringSize}`;

    if (netWeight)
      message += `
Net Weight: ${netWeight}`;

    if (stoneWeight)
      message += `
Stone Weight: ${stoneWeight}`;

    if (grossWeight)
      message += `
Gross Weight: ${grossWeight}`;

    if (engraving)
      message += `
Engraving: ${engraving}`;

    message += `

Please share the final quotation.

Thank you.`;

    const url =
      "https://wa.me/" +
      phone +
      "?text=" +
      encodeURIComponent(message);

    window.open(url, "_blank");
  });
});